import { environment } from '../../../environments/environment';

/** API_URLS */
export const API_URLS = {
    PROCESS: {
        START: environment.baseUrlMint + '/rest/process/start/',
        STEP: environment.baseUrlMint + '/rest/process/step',
        VLUXGATE_START: environment.baseUrlVluxgate + '/vlux/start/module/',
        VLUXGATE_STEP: environment.baseUrlVluxgate + '/vlux/step/module',
        RESEND_MTAN: environment.baseUrlVluxgate + '/vlux/send-tan',
    },
    ECARE_ROUTES: {
        DASHBOARD: '/meinvodafone/services/',
        CONTRACT_CHOOSER: '/meinvodafone/services/vertragsauswahl',
        QUICK_CHECK_TOPUP: '/meinvodafone/services/teilnehmer/quickcheck?accordion=kostendetails',
    },
    LOGIN: {
        SESSION_START: environment.baseUrlMint + '/rest/session/start', // for mdev use only
    },
    LOGOUT: {
        LOGOUT: environment.baseUrlMint + '/saml/logout',
    },
    PAYMENT: {
        PAYMENT_CONFIG: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/payment-management/v1/payment/config?usecase={usecase}&client-id={client-id}&channel-id={channel-id}',
        PAYMENT_METHOD: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/customer/customer-accounts/{id}/payment-methods?usecase={usecase}&client-id={client-id}&channel-id={channel-id}&id-type={id-type}',
        SHOPPER_STATUS_POST: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/payment-management/v1/payment/shopper-status',
        PAYMENT_CREATION_POST: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/payment-management/v1/payment',
        PAYMENT_STATUS_GET: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/payment-management/v1/payment/{payment-id}/status?usecase={usecase}&client-id={client-id}&channel-id={channel-id}',
        PAYMENT_STATUS_PUT: environment.baseUrlNil + '/enterprise-resources/core/bss/cus-nil/payment-management/v1/payment/{payment-id}/status',
    },
};
/** PROCESS_ROUTES */
export const PROCESS_ROUTES: Array<string> = [
    API_URLS.PROCESS.STEP,
    API_URLS.PROCESS.START,
    API_URLS.PROCESS.VLUXGATE_START,
    API_URLS.PROCESS.VLUXGATE_STEP,

];
